import React from 'react';
import Header from '../components/header';
import { useLocation, useNavigate } from 'react-router-dom';

function GameDetail() {
  const location = useLocation();
  const navigate = useNavigate();
  const { name } = location.state || {};
  return (
    <div className='main-2'>
      <Header title={name} isBack bgColor />
      <div className='container my-auto'>
        <button
          className='play-button mt-3 btn'
          onClick={() =>
            navigate('/singlenumberplay', {
              state: { name: name, type: 'Single Number Play' },
            })
          }
        >
          Single Number Play
        </button>
        <button
          className='play-button mt-3 btn'
          onClick={() => navigate('/houseplay',{
            state: { name: name, type: 'House Play' },
          })}
        >
          House Play
        </button>
        <button
          className='play-button mt-3 btn'
          onClick={() => navigate('/endingplay',{
            state: { name: name, type: 'Ending Play' },
          })}
        >
          Ending Play
        </button>
      </div>
    </div>
  );
}

export default GameDetail;
